import { ImageLoaderProps } from "next/image";

export default function staticImageLoader({ src }: ImageLoaderProps) {
  return `${process.env.NEXT_PUBLIC_CLIENT_SERVER}${src}`;
}
